/**
 * Base roof types - extracted to break circular dependency between
 * roofTypes.ts and roofSettings.ts
 */
import type { ExteriorMaterial } from "building-types/materials/exteriorMaterialTypes";
import type { Formula, RemoveFormula } from "building-types/options/formula";
import type { ProfileId } from "building-types/profiles/profileTypes";

export enum EaveBracketSide {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  BOTH = "BOTH",
  ALL = "ALL",
}

export enum EaveBracketPlacement {
  START_TO_END = "START_TO_END",
  END_TO_START = "END_TO_START",
}

export enum RoofTruncationType {
  NONE = "NONE",
  TRUNCATED = "TRUNCATED",
  HIP = "HIP",
}

export enum TruncationSlopeType {
  OVERRIDE = "OVERRIDE",
  SIDE_SLOPES = "SIDE_SLOPES",
  FROM_HOST = "FROM_HOST",
}

/**
 * The following data structure consolidates the frieze board
 */
export interface FriezeBoard {
  readonly name: string;
  readonly friezeBoard: ProfileId;
  readonly friezeBoardMaterial?: ExteriorMaterial;
  readonly verticalOffset?: number;
  readonly lateralOffset?: number;
}

/**
 * Slope definition for a roof.
 */
export interface RoofSlopeOptions {
  readonly slope: number | Formula;
  readonly horizontalDist?: number;
}

export type EvaluatedRoofSlopeOptions = RemoveFormula<RoofSlopeOptions>;
